import React from 'react';
import PropTypes from 'prop-types';
import { PopOutIcon } from './PopOutIcon';
import './FolderItem.scss';

export const FolderItem = ({ image, content, button, className = '', popoutLink }) => {
  return (
    <div className={className}>
      { image }
      { content }
      <div className='iconsContainer'>
        { popoutLink && <PopOutIcon link={popoutLink}/>}
        { button }
      </div>
    </div>
  );
};

FolderItem.propTypes = {
  image: PropTypes.element,
  content: PropTypes.element,
  button: PropTypes.any,
  className: PropTypes.string,
  popoutLink: PropTypes.string,
};
